import type { FC, PropsWithChildren } from 'react';

import { useFeature } from '@/features/feature-management/provider/useFeature';
import type { FeaturesEnum } from '@/features/feature-management/types/features';

type Props = PropsWithChildren<{
  features: FeaturesEnum[];
}>;

export const FeatureGuard: FC<Props> = ({ features, children }) => {
  const { isFeatureEnabled } = useFeature();

  if (!features.every((it) => isFeatureEnabled(it))) {
    return;
  }

  return <>{children}</>;
};
